/**
 * Tour Steps Configuration
 * Defines all steps for the "What's New" tour
 * Easy to modify, add, or remove steps for future iterations
 */
import React from "react"
import type { TourProps } from "antd"
import { DotLottieReact } from "@lottiefiles/dotlottie-react"

export interface TourStep {
  title: string
  description: React.ReactNode
  target?: () => HTMLElement | null
  placement?: TourProps["placement"]
  nextButtonProps?: {
    children?: string
  }
}

export const TOUR_STEPS: TourStep[] = [
  {
    title: "Welcome to the DATA(Q) Questionnaire Editor! 🎉",
    description: (
      <div>
        <DotLottieReact
          src="https://lottie.host/7703f3e9-94fe-4b9a-ab6f-3ae81e93d8d2/0bulP11pi6.lottie"
          loop
          autoplay
          style={{ width: "100%", height: "200px", marginBottom: "16px" }}
        />
        <p>
          We've added some exciting new features to help you work faster. Let's
          take a quick tour!
        </p>
      </div>
    ),
    placement: "center",
    nextButtonProps: {
      children: "Get Started",
    },
  },
  {
    title: "Metadata Manager",
    description:
      "Manage your survey's semantic layer in one place: edit question labels and lists, and review the variable codes and value codes your data file will use. Click here to open it.",
    placement: "bottom",
  },
  {
    title: "Structure Panel",
    description:
      "Get a bird's eye view of your questionnaire structure. Click this button (or press Ctrl+Shift+E) to toggle the structure tree view.",
    placement: "bottom",
  },
  {
    title: "Add Survey Elements",
    description:
      "Quickly insert survey elements with this modal. Click to browse templates or drag them directly into your structure tree!",
    placement: "bottom",
  },
  {
    title: "Element Highlighting",
    description:
      "Toggle visual highlighting to see question types, sections, and other elements at a glance. Perfect for reviewing complex questionnaires.",
    placement: "bottom",
  },
  {
    title: "Context Menu",
    description:
      "Right-click on any element in the editor to access quick actions like finding usages, jumping to labels, and more context-specific options.",
    placement: "top",
  },
  {
    title: "You're All Set! ✓",
    description:
      "That's it! You can always access this tour again from the help menu. Happy surveying!",
    placement: "center",
    nextButtonProps: {
      children: "Got it!",
    },
  },
]
